
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "falcon-atlas-bridge"
    }}>{`Falcon Atlas Bridge`}</h1>
    <h2 {...{
      "id": "falcon-model"
    }}>{`Falcon Model`}</h2>
    <p>{`The default hive model includes the following types:`}</p>
    <ul>
      <li parentName="ul">{`Entity types:`}
        <ul parentName="li">
          <li parentName="ul">{`falcon_cluster`}
            <ul parentName="li">
              <li parentName="ul">{`super-types: Infrastructure`}</li>
              <li parentName="ul">{`attributes: timestamp, colo, owner, tags`}</li>
            </ul>
          </li>
          <li parentName="ul">{`falcon_feed`}
            <ul parentName="li">
              <li parentName="ul">{`super-types: DataSet`}</li>
              <li parentName="ul">{`attributes: timestamp, stored-in, owner, groups, tags`}</li>
            </ul>
          </li>
          <li parentName="ul">{`falcon_feed_creation`}
            <ul parentName="li">
              <li parentName="ul">{`super-types: Process`}</li>
              <li parentName="ul">{`attributes: timestamp, stored-in, owner`}</li>
            </ul>
          </li>
          <li parentName="ul">{`falcon_feed_replication`}
            <ul parentName="li">
              <li parentName="ul">{`super-types: Process`}</li>
              <li parentName="ul">{`attributes: timestamp, owner`}</li>
            </ul>
          </li>
          <li parentName="ul">{`falcon_process`}
            <ul parentName="li">
              <li parentName="ul">{`super-types: Process`}</li>
              <li parentName="ul">{`attributes: timestamp, runs-on, owner, tags, pipelines, workflow-properties`}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <p>{`One falcon_process entity is created for every cluster that the falcon process is defined for.`}</p>
    <p>{`The entities are created and de-duped using unique qualifiedName attribute. They provide namespace and can be used for querying/lineage as well. The unique attributes are:`}</p>
    <ul>
      <li parentName="ul">{`falcon_process.qualifiedName          - `}<inlineCode parentName="li">{`<process name>@<cluster name>`}</inlineCode></li>
      <li parentName="ul">{`falcon_cluster.qualifiedName          - `}<inlineCode parentName="li">{`<cluster name>`}</inlineCode></li>
      <li parentName="ul">{`falcon_feed.qualifiedName             - `}<inlineCode parentName="li">{`<feed name>@<cluster name>`}</inlineCode></li>
      <li parentName="ul">{`falcon_feed_creation.qualifiedName    - `}<inlineCode parentName="li">{`<feed name>`}</inlineCode></li>
      <li parentName="ul">{`falcon_feed_replication.qualifiedName - `}<inlineCode parentName="li">{`<feed name>`}</inlineCode></li>
    </ul>
    <h2 {...{
      "id": "falcon-hook"
    }}>{`Falcon Hook`}</h2>
    <p>{`Falcon supports listeners on falcon entity submission. This is used to add entities in Atlas using the model detailed above.
Follow the instructions below to setup Atlas hook in Falcon:`}</p>
    <ul>
      <li parentName="ul">{`Add 'org.apache.atlas.falcon.service.AtlasService' to application.services in `}<inlineCode parentName="li">{`<falcon-conf>`}</inlineCode>{`/startup.properties`}</li>
      <li parentName="ul">{`untar apache-atlas-\${project.version}-falcon-hook.tar.gz`}</li>
      <li parentName="ul">{`cd apache-atlas-falcon-hook-\${project.version}`}</li>
      <li parentName="ul">{`Copy entire contents of folder apache-atlas-falcon-hook-\${project.version}/hook/falcon to `}<inlineCode parentName="li">{`<atlas-home>`}</inlineCode>{`/hook/falcon`}</li>
      <li parentName="ul">{`Link Atlas hook jars in Falcon classpath - 'ln -s `}<inlineCode parentName="li">{`<atlas-home>`}</inlineCode>{`/hook/falcon/* `}<inlineCode parentName="li">{`<falcon-home>`}</inlineCode>{`/server/webapp/falcon/WEB-INF/lib/'`}</li>
      <li parentName="ul">{`In `}<inlineCode parentName="li">{`<falcon_conf>`}</inlineCode>{`/falcon-env.sh, set an environment variable as follows:`}</li>
    </ul>
    <SyntaxHighlighter wrapLines={true} language="java" style={theme.dark} mdxType="SyntaxHighlighter">
     {`export FALCON_SERVER_OPTS="<atlas_home>/hook/falcon/*:$FALCON_SERVER_OPTS"`}
     </SyntaxHighlighter>
    <p>{`The following properties in `}<inlineCode parentName="p">{`<atlas-conf>`}</inlineCode>{`/atlas-application.properties control the thread pool and notification details:`}</p>
    <ul>
      <li parentName="ul">{`atlas.hook.falcon.synchronous   - boolean, true to run the hook synchronously. default false`}</li>
      <li parentName="ul">{`atlas.hook.falcon.numRetries    - number of retries for notification failure. default 3`}</li>
      <li parentName="ul">{`atlas.hook.falcon.minThreads    - core number of threads. default 5`}</li>
      <li parentName="ul">{`atlas.hook.falcon.maxThreads    - maximum number of threads. default 5`}</li>
      <li parentName="ul">{`atlas.hook.falcon.keepAliveTime - keep alive time in msecs. default 10`}</li>
      <li parentName="ul">{`atlas.hook.falcon.queueSize     - queue size for the threadpool. default 10000`}</li>
    </ul>
    <p>{`Refer `}<a parentName="p" {...{
        "href": "#/Configuration"
      }}>{`Configuration`}</a>{` for notification related configurations`}</p>
    <h2 {...{
      "id": "notes"
    }}>{`NOTES`}</h2>
    <ul>
      <li parentName="ul">{`In falcon cluster entity, cluster name used should be uniform across components like hive, falcon, sqoop etc. If used with ambari, ambari cluster name should be used for cluster entity`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;